<template>
  <span>
    <template v-if="exception">
      <span class="icon-color-red"><i class="el-icon-warning icon-color-red" />&nbsp;{{ status==4?'已过期':reason }}</span>
    </template>
    <template v-else>
      <el-tag class="tag-status" v-if="status==2" :style="effective">有效</el-tag>
      <el-tag class="tag-status" v-if="status==1 || status==6" :style="review">审核中</el-tag>
      <el-tag class="tag-status" v-if="status==3 || status==5" :style="reject">驳回</el-tag>
      <el-tag class="tag-status" v-if="status==4" :style="expired">过期</el-tag>
    </template>
  </span>
</template>
<script>
export default {
  name: 'LicenseStatus',
  props: {
    status: {
      type: Number,
      default: 0
    },
    background: {
      type: String,
      default: '#FFFFFF'
    },
    exception: {
      type: Boolean,
      default: false
    },
    reason: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      expired: {
        padding: '1px 14px 2px',
        fontSize: '12px',
        marginLeft: '5px',
        fontWeight: 'normal',
        // background: this.background,
        border: '1px solid #A5ABC6',
        color: '#A5ABC6'
      },
      effective: {
        padding: '1px 14px 2px',
        fontSize: '12px',
        marginLeft: '5px',
        fontWeight: 'normal',
        // background: this.background,
        border: '1px solid #2A60E4',
        color: '#2A60E4'
      },
      review: {
        padding: '1px 14px 2px',
        fontSize: '12px',
        marginLeft: '5px',
        fontWeight: 'normal',
        // background: this.background,
        border: '1px solid #75B430',
        color: '#75B430'
      },
      reject: {
        padding: '1px 14px 2px',
        fontSize: '12px',
        marginLeft: '5px',
        fontWeight: 'normal',
        // background: this.background,
        border: '1px solid #C82439',
        color: '#C82439'
      }
    }
  }
}

</script>
<style scoped>
  .icon-color-red {
    font-size: 12px;
    color: #CE3B4F;
  }
  .tag-status{
    background: #f7f7f7;
    border-radius: 12px;
    height: 24px;
    line-height: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/status/LicenseStatus.vue